import React from 'react';
import { connect } from 'react-redux';
import Loading from 'views/Loading';
import Carousel from 'nuka-carousel';
import Icon from 'views/Icon';

import {
  requestProfile,
} from '../../actions/ProductActions';

import {
  getOfferPriceLabel,
} from 'utils/labelUtils';

import {
  getOfferSlug,
} from '../../reducers/ProductReducers';

const commonStyle = {
  background: '#FFF',
  color: '#3B96E0',
  padding: '7px',
  borderRadius: '4px',
  fontSize: '25px',
};

const carouselSettings = {
  slidesToShow: 2,
  wrapAround: true,
  decorators: [
    {
      component: ({ previousSlide }) => (
        <button
          className="slider-control-btn"
          onClick={(e) => {
          e.preventDefault();
          previousSlide();
        }}>
          <Icon className="arrows-1_minimal-left" style={{ fontWeight: 'bold', marginRight: '0px' }}/>
        </button>
      ),
      position: 'CenterLeft',
      style: {
        ...commonStyle,
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        left: '-1px',
      },
    },
    {
      component: ({ nextSlide }) => (
        <button
          className="slider-control-btn"
          onClick={(e) => {
          e.preventDefault();
          nextSlide();
        }}>
          <Icon className="arrows-1_minimal-right" style={{ fontWeight: 'bold', marginRight: '0px' }}/>
        </button>
      ),
      position: 'CenterRight',
      style: {
        ...commonStyle,
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
        right: '-1px',
      },
    },
  ],
};

class ProductCarousel extends React.Component {
  componentDidMount () {
    this.props.requestProfile();
  }

  render () {
    const { offers = [] } = this.props.storeOffers;
    const { product } = this.props;

    const offersDom = offers.reduce((filteredOffers, offer, index) => {
      const { title, previewUrl, url, priceBoost, minPrice, maxPrice, slug } = offer;
      if ((getOfferSlug(product) !== slug) && previewUrl) {
        filteredOffers.push(
          <div key={index} className="soft-quarter--sides">
            <div className="slider-item">
              <a href={`${url}?ref=offer_page_more`} target="_blank">
                <div className="slider-item__image" style={previewUrl ? { backgroundImage: `url(${previewUrl})` } : { background: '#DEE5EB' }}>
                </div>
                <div className="slider-item__info--title font-rc text-overflow-ellipsis">
                  {title}
                </div>
                <div className="slider-item__info--price">
                  {getOfferPriceLabel({ priceBoost, minPrice, maxPrice })}
                </div>
              </a>
            </div>
          </div>
        );
      }
      return filteredOffers;
    }, []);

    return offersDom.length > 2 ? (
      <div className="push--top offer-sidebar">
        <div className="caps sidebar-content text-grey soft--bottom">More from this Store</div>
        <div className="product-carousel">
          { offers.length ?
            <Carousel {...carouselSettings}>
              {offersDom}
            </Carousel> :
            <Loading />
          }
        </div>
      </div> ) :
      null;
  }
}

const mapStateToProps = (state) => {
  const { storeOffers, product } = state;
  return {
    storeOffers,
    product,
  };
};

export default connect(mapStateToProps, {
  requestProfile,
})(ProductCarousel);



// WEBPACK FOOTER //
// ./src/product/views/_layout/ProductCarousel.js